import React from 'react'
import Table from '../Table'
import styles from './dummyMenu.module.scss'

const MenuTable = ({
  title,
  description,
  columns = [],
  data = [],
  showSortDaily = false
}) => {
  // Handle empty data
  if (!data || data.length === 0) {
    return (
      <div className={styles.tableSection}>
        <div className={styles.tableHeader}>
          <h2 className={styles.tableTitle}>{title}</h2>
          {description && (
            <p className={styles.tableDescription}>{description}</p>
          )}
        </div>
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📊</div>
          <div className={styles.emptyText}>No data available</div>
          <div className={styles.emptySubtext}>There are no transactions to display</div>
        </div>
      </div>
    )
  }
  // Format data for the existing Table component
  const formattedData = data.map((row, index) => ({
    ...row,
    // Format nominal as number with thousand separators
    nominal: new Intl.NumberFormat('id-ID').format(row.nominal),
    biaya: new Intl.NumberFormat('id-ID').format(row.biaya)
  }))

  // Table configuration
  const tableConfig = {
    columns: columns,
    withIndex: true,
    total: data.length,
    limit: 10,
    currentPage: 1,
    showRender: true,
    pagination: true,
    loading: false,
    sort: 'tanggal|desc',
    collapse: false
  }

  return (
    <div className={styles.tableSection}>
      <div className={styles.tableHeader}>
        <h2 className={styles.tableTitle}>{title}</h2>
        {description && (
          <p className={styles.tableDescription}>{description}</p>
        )}
        {showSortDaily && (
          <div className={styles.sortOption}>
            Sort Daily
          </div>
        )}
      </div>
      
      <Table
        data={formattedData}
        config={tableConfig}
        onSort={() => {}}
        onChangePage={() => {}}
        onLimit={() => {}}
      />
    </div>
  )
}

export default MenuTable